module.exports = __webpack_public_path__ + "static/media/error.74ba1167.svg";